import { detectDeviceType } from './device.ts';
import { formatTemplate, onTranslationsApplied, t } from './localization.ts';
import { goToRelative } from './slides.ts';

function setupScrollIndicator(): void {
  const scrollIndicator = document.querySelector('.scroll-indicator') as HTMLElement | null;
  if (!scrollIndicator) {
    window.requestAnimationFrame(setupScrollIndicator);
    return;
  }

  if (scrollIndicator.dataset.enhanced === 'true') {
    return;
  }

  scrollIndicator.dataset.enhanced = 'true';

  const reveal = (): void => {
    scrollIndicator.classList.add('is-visible');
  };

  window.setTimeout(reveal, 1500);

  scrollIndicator.addEventListener('click', () => {
    goToRelative(1, { source: 'hero-arrow' });
  });
}

function applyHeroTitleVariant(): void {
  const heroTitleEl = document.querySelector('[data-i18n="hero.title"]');
  if (!heroTitleEl) return;

  const deviceType = detectDeviceType().toLowerCase();
  let key: string = 'hero.titleDefault';

  if (deviceType === 'mobile') {
    key = 'hero.titlePhone';
  }

  const existing = heroTitleEl.innerHTML;
  const fallbackVariant = t('hero.title') || existing;
  const variant = t(key) || fallbackVariant || existing;
  if (variant !== undefined && variant !== null) {
    heroTitleEl.innerHTML = variant;
  }
}

function applyHeroSubtitleVariant(): void {
  const heroSubtitleEl = document.querySelector('[data-i18n="hero.subtitle"]');
  if (!heroSubtitleEl) return;

  const deviceType = detectDeviceType().toLowerCase();
  const target = deviceType === 'mobile' ? 'phone' : 'devices';

  const fallback = 'your first training on taming your {{target}} starts now';
  const template = t('hero.subtitle', fallback) || fallback;
  heroSubtitleEl.innerHTML = formatTemplate(template, { target });
}

function initHero(): void {
  applyHeroTitleVariant();
  applyHeroSubtitleVariant();
  onTranslationsApplied(() => {
    applyHeroTitleVariant();
    applyHeroSubtitleVariant();
  });
  setupScrollIndicator();
}

export { applyHeroSubtitleVariant, applyHeroTitleVariant, initHero };
